<template>
  <image-container-card
    as="a"
    v-bind="$attrs"
    v-on="$listeners"
    :image="item.thumbnail || item.image"
  >
    <align justify="space-between">
      <div class="platform-text">{{ item.platform }}</div>

      <countdown-timer
        v-if="item.endDate && item.listingType === 'Auction'"
        :end-time="item.endDate"
      />
    </align>

    <div class="item-text">{{ item.title }}</div>

    <align direction="flex-end" justify="space-between">
      <card-stat-item
        :card="item"
        stat="price"
      />

      <div class="extra-info" v-if="item.bids != null || item.watchers != null || item.listingType === 'Best Offer'">
        <span v-if="item.bids != null">Bids: {{ item.bids }}</span>
        <span v-if="item.watchers != null">Watchers: {{ item.watchers }}</span>
        <span v-if="item.listingType === 'Best Offer'">or Best Offer</span>
      </div>
    </align>
  </image-container-card>
</template>

<script>
import Align from './Align';
import CardStatItem from './CardStatItem';
import CountdownTimer from './CountdownTimer';
import ImageContainerCard from './ImageContainerCard';

export default {
  components: {
    Align,
    CardStatItem,
    CountdownTimer,
    ImageContainerCard,
  },

  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.countdown-timer {
  transform: scale(0.9);
}

.item-text {
  margin-bottom: $gp * .5;
  font-weight: bold;
  font-size: 18px;

  @media($small-up) {
    height: 80px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.extra-info {
  display: flex;
  flex-direction: column;
  text-align: right;
  padding-bottom: 5px;

  span {
    font-size: 12px;
    font-weight: bold;
  }
}

.platform-text {
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.5;
  letter-spacing: 1px;
}
</style>
